export interface IParticipantsResponse {
  totalEntityCount: number;
  totalPageCount: number;
  entities: IParticipant[];
}

export interface IParticipant {
  contractTitle: string;
  country: string;
  department: string;
  directSupervisorEmail: string;
  email: string;
  firstName: string;
  id: string;
  isIncluded: boolean;
  lastName: string;
  middleName: string | null;
  subDepartment: string;
  talkStatus?: string;
  team: string;
  tenure: number;
  workplace: string;
}

export enum ParticipantActions {
  REOPENED = "REOPENED",
  REMOVED = "REMOVED",
  ADDED = "ADDED",
  REASSIGNED = "REASSIGNED",
  CANCELLED = "CANCELLED"
}

export const ParticipantActionStatuses = {
  [ParticipantActions.REOPENED]: "REOPENED",
  [ParticipantActions.REMOVED]: "REMOVED",
  [ParticipantActions.ADDED]: "ADDED",
  [ParticipantActions.REASSIGNED]: "REASSIGNED",
  [ParticipantActions.CANCELLED]: "CANCELLED"
};
